<template>
  <SSOBody />
</template>

<script>
import SSO from "../components/mixins/SSO";
import SSOBody from "../components/misc/SSOBody";
import { mapActions } from "vuex";
export default {
  name: "SSO",
  mixins: [SSO],
  components: { SSOBody },
  methods: {
    ...mapActions(["sso"]),
    startupTask() {
      return this.sso(this.$route.query)
        .then(data => {
          if ("URLEncryptQStrArgs" in this.searchParams){
            this.searchParams = data.decrypted || {};
          }
        });
    }
  }
};
</script>